module.exports = __webpack_public_path__ + "img/compliance.133d7084.png";